export default __webpack_public_path__ + "static/media/avatar-6.fd2f1f79.jpg";